export default "__VITE_ASSET__Cm_4mUCn__"